// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const tipsApi = createApi({
    reducerPath: "tipsApi",
    baseQuery: encryptedBaseQueryWithReauth(),
    tagTypes: ["getTermsList"],
    endpoints: (builder) => ({
        getTipsList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getTermsList"],
        }),

        getSingleTips: builder.query({
            query: (endpoint) => `${endpoint}`,
        }),
        getListData: builder.query({
            query: (endpoint) => `${endpoint}`,
        }),

        getEntityList: builder.query({
            query: (endpoint) => `${endpoint}`,
        }),

        deleteTips: builder.mutation({
            query: (endpoint) => ({
                url: `${endpoint}`,
                method: "DELETE",
            }),
            invalidatesTags: ["getTermsList"],
        }),

        addTips: builder.mutation({
            query: ({ endpoint, data }) => ({
                url: endpoint,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["getTermsList"],
        }),

        updateTips: builder.mutation({
            query: ({ endpoint, updateTips }) => ({
                url: endpoint,
                method: "PATCH",
                body: updateTips,
            }),
            invalidatesTags: (result) => {
                if (result?.success) {
                    return ["getSubjectList"]
                }
            },
        }),

        statusTips: builder.mutation({
            query: ({ endpoint, isPublished }) => {


                return {
                    url: `${endpoint}`,
                    method: 'PATCH',
                    body: {
                        isPublished
                    },
                };
            },
        }),
    }),
});

export const {
    useGetTipsListQuery,
    useGetSingleTipsQuery,
    useDeleteTipsMutation,
    useAddTipsMutation,
    useUpdateTipsMutation,
    useGetListDataQuery,
    useGetEntityListQuery,
    useStatusTipsMutation,
} = tipsApi;
